// @flow
import * as React from 'react';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import PublishYourCvComponent from './index';
import {
  showRedirectingTo,
  setRedirectingToPublishYourCv,
} from '../../../Sources/redirectingTo/actions';
import { getPublishYourCvUrl } from '~/common/selectors/trovit';

type Props = {
  publishYourCvUrl: ?string,
  redirectToSource: Function,
  setPublishYourCvRedirect: Function,
  redirectToSource: Function,
};

type MapStateToProps = {
  publishYourCvUrl: ?string,
};

type MapDispatchToProps = {
  setPublishYourCvRedirect: Function,
  redirectToSource: Function,
};

class PublishYourCv extends React.Component<Props> {
  handleClick = () => {
    const { redirectToSource, publishYourCvUrl, setPublishYourCvRedirect } = this.props;

    setPublishYourCvRedirect(true);
    redirectToSource(publishYourCvUrl);
  };

  render() {
    return <PublishYourCvComponent handleClick={this.handleClick} {...this.props} />;
  }
}

function mapStateToProps(state: Object): MapStateToProps {
  return {
    publishYourCvUrl: getPublishYourCvUrl(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    setPublishYourCvRedirect: () => dispatch(setRedirectingToPublishYourCv(true)),
    redirectToSource: url => dispatch(showRedirectingTo(url)),
  };
}

const PublishYourCvContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishYourCv);
PublishYourCvContainer.displayName = 'PublishYourCvContainer';

export default PublishYourCvContainer;



// WEBPACK FOOTER //
// ./app/Serp/components/PublishYourCv/container.js